module.exports = __webpack_public_path__ + "assets/img/live22_app.fc508f61.png";